export default "__VITE_ASSET__BFH3VYXr__"